module.exports = __webpack_public_path__ + "img/skull_3.7de2bc27.png";